import { Controller } from "@hotwired/stimulus"

// this is tightly coupled with views/backoffice/quoted_wares_proposals/_form.html.haml
export default class extends Controller {
  static targets = [
    'commissionRate', // a hiden field at the top of the form
    'legacyFeeAssignment',
    'transactionFeeAssignment',
    'transactionFeeTitle',
    'transactionFeeDescription',
    'transactionFeeCustomerFee',
    'transactionFeeProviderFee',
  ]
  static outlets = ["toggle-class"]
  static values = { directBilling: { "type": Boolean, "default": false } }

  connect() {
    this.handleTransactionFeeChange();
  }

  toggleClassOutletConnected(outlet) {
    if (this.hasFeeSelected) {
      outlet.off()
    } else {
      outlet.on()
    }
  }

  handleTransactionFeeChange() {
    this.updateTransactionFeeFields();
    if (this.hasFeeSelected) {
      this.dispatch('selected', { detail: { fee: this.getFee() } })
    } else {
      this.dispatch('not-selected', { detail: { fee: this.getFee() } })
    }
  }

  get hasFeeSelected() {
    if (this.directBillingValue) { return true }
    return (this.hasLegacyFeeAssignmentTarget && this.legacyFeeAssignmentTarget.value !== "") || (this.hasTransactionFeeAssignmentTarget && this.transactionFeeAssignmentTarget.value !== "");
  }

  get legacyFeeAssignment() {
    if (!this.hasLegacyFeeAssignmentTarget) { return ''; }
    return this.legacyFeeAssignmentTarget.value;
  }

  get transactionFeeAssignment() {
    if (!this.hasTransactionFeeAssignmentTarget) { return ''; }
    return this.transactionFeeAssignmentTarget.selectedOptions;
  }

  getFee() {
    let fee;
    if (this.hasLegacyFeeAssignmentTarget) {
      fee = this.legacyFee();
    } else if (this.hasTransactionFeeAssignmentTarget) {
      fee = this.transactionFee();
    } else {
      fee = {};
    }
    fee.feeSelected = this.hasFeeSelected
    return fee
  }

  get commissionRate() {
    let rate = parseFloat(this.commissionRateTarget.value);
    if (Number.isFinite(rate)) {
      return rate;
    }
    return 0;
  }

  legacyFee() {
    const commissionRate = this.commissionRate;
    const type = this.legacyFeeAssignment;
    let feeObj
    if (type === "supplier") {
      feeObj = {
        type: "legacy-supplier",
        providerFee: commissionRate,
        customerFee: 0
      }
    } else if (type === "customer") {
      feeObj = {
        type: "legacy-customer",
        providerFee: 0,
        customerFee: commissionRate
      }
    } else if (type === "split") {
      const splitRate = commissionRate / 2;
      feeObj = {
        type: "legacy-split",
        providerFee: splitRate,
        customerFee: splitRate
      }
    } else {
      feeObj = {}
    }
    return Object.assign(feeObj, { commissionRate, title: '', description: '' });
  }

  transactionFee() {
    const selectedOption = this.transactionFeeAssignmentTarget.selectedOptions[0]
    let providerFee = parseFloat(selectedOption.getAttribute('provider_fee'));
    if (!Number.isFinite(providerFee)) { providerFee = 0 }
    let customerFee = parseFloat(selectedOption.getAttribute('customer_fee'));
    if (!Number.isFinite(customerFee)) { customerFee = 0 }
    const commissionRate = providerFee + customerFee
    return {
      type: "transactionFee",
      title: selectedOption.label,
      description: selectedOption.title,
      providerFee,
      customerFee,
      commissionRate
    }
  }

  updateTransactionFeeFields() {
    if (!this.hasTransactionFeeAssignmentTarget) { return }
    const feeData = this.transactionFee();
    this.transactionFeeTitleTarget.value = feeData.title;
    this.transactionFeeDescriptionTarget.value = feeData.description;
    this.transactionFeeCustomerFeeTarget.value = feeData.customerFee;
    this.transactionFeeProviderFeeTarget.value = feeData.providerFee;
  }
}
